var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFurtherPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 442.927,
    height: 180.749,
    viewBox: "0 0 442.927 180.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3255.642 -4814.247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3269.371 4982.47l3.392-1.052c2.26-.7 6.78.452 9.545 1.3a2.469 2.469 0 003.083-1.621h0a2.475 2.475 0 00-1.694-3.129l-8.778-2.453a12.659 12.659 0 00-11.064 2.113l-7.714 5.862v10.816l9.513-3.136 11.6 1.3a9.251 9.251 0 006.08-1.486l19.169-13.717a2.125 2.125 0 00.667-2.833h0a2.125 2.125 0 00-2.847-.809l-15.364 8.271",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3283.697 4977.962l8.254-4.567a7.553 7.553 0 016.037-.558l2.339.779m-21.841 2.898l6.616-3.665a9.324 9.324 0 016.705-.909l2.152.519",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3278.455 4945.506l-11.871 6.539a.582.582 0 00-.3.507v11.59a.58.58 0 00.3.507l11.871 6.54a.581.581 0 00.559 0l11.87-6.54a.578.578 0 00.3-.507v-11.59a.58.58 0 00-.3-.507l-11.87-6.539a.578.578 0 00-.559 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290.967 4952.129l-12.274 6.858-12.273-6.858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3290.967 4952.129l-12.274 6.858v12.274"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3455.578 4881.288)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#6e7e9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.127 7.121l-12.14 6.688a.594.594 0 00-.307.519v11.851a.593.593 0 00.307.519l12.14 6.688a.588.588 0 00.571 0l12.14-6.687a.593.593 0 00.307-.519V14.329a.594.594 0 00-.307-.519l-12.14-6.687a.593.593 0 00-.571-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.923 13.893l-12.551 7.014-12.551-7.014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.923 13.893l-12.551 7.014v12.552"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 80.827,
    height: 49.766,
    rx: 3.296,
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M33.366 49.766h14.095v11.298H33.366zM22.865 61.064h35.111M.043 39.998h80.755"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3278.485 4897.863v9.5m0 0l4.222-2.49-4.222-7.01h0l-4.222 7.01 4.222 2.5z",
    fill: "none",
    stroke: "#6e7e9d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3278.483 4911.62h0l4.224-5.949-4.224 2.494h0l-4.222-2.494 4.222 5.949zm0-3.455v3.456m4.221-6.752l-4.221-1.918m.002-.003l-4.222 1.921",
    fill: "none",
    stroke: "#6e7e9d",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3278.694 4945.27v-25.956m-.214-29.39v-51.739h69.319"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3638.074 4875.161)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.948 47.512v14.722a1.435 1.435 0 01-1.435 1.435H1.433a1.434 1.434 0 01-1.434-1.435v-60.8A1.434 1.434 0 011.433 0h30.08a1.434 1.434 0 011.435 1.434v13.467M0 10.936h32.948M0 52.531h32.948M12.477 5.199h7.172"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.494,
    cy: 1.494,
    r: 1.494,
    transform: "translate(14.98 56.714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.005 19.214v-2.779a1.535 1.535 0 011.534-1.535h44.92a1.534 1.534 0 011.534 1.535v29.542a1.534 1.534 0 01-1.534 1.534h-44.92a1.534 1.534 0 01-1.534-1.534V19.214m.471 3.197h47.519m-47.519 5.737h47.519M16.779 42.491h15.777m-15.777-5.737h10.04"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3353.486 4906.672h54.709m-54.709 43.816h54.709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3342.18 4855.354h77.183v.723a6.885 6.885 0 01-6.883 6.886h-63.415a6.885 6.885 0 01-6.885-6.886v-.723h0zm33.242 2.697h9.733m-34.31-43.304h59.854a3.046 3.046 0 013.046 3.046v37.561h0-65.946 0v-37.561a3.046 3.046 0 013.046-3.046z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3353.486 4820.765h54.709v34.589h-54.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3353.486 4820.765h54.709v34.589h-54.709z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3368.07 4915.248)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.614 17.084a8.041 8.041 0 00-.153-1.555l2.044-1.008-1.843-3.735-1.9 1.011a9.677 9.677 0 00-3.783-2.443V7.565h-4.073v1.789a7.728 7.728 0 00-4.119 2.443l-2.145-1.011-1.89 3.735 2.02 1.008a7.806 7.806 0 00-.017 3.11l-2.047 1.008 1.841 3.735 2.24-1.011a7.73 7.73 0 004.118 2.443v1.957h4.073v-1.957a9.688 9.688 0 003.783-2.443l1.979 1.011 1.805-3.735-2.062-1.008a8.038 8.038 0 00.129-1.555z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.259,
    cy: 2.259,
    r: 2.259,
    transform: "translate(13.296 14.781)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.972,
    cy: 3.972,
    r: 3.972,
    transform: "translate(11.583 13.068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.287 4.903a4.1 4.1 0 00-.08-.806l1.059-.522-.954-1.936-1 .524A5.225 5.225 0 006.337.897v-.9H4.01v.9a5.354 5.354 0 00-2.011 1.266L.95 1.639.002 3.575l1.062.522a4.1 4.1 0 00-.079.806 4.193 4.193 0 00.081.806L.007 6.23l.955 1.936 1.037-.524A5.345 5.345 0 004.01 8.908v.985h2.327v-.984a5.225 5.225 0 001.975-1.266l1.032.524.94-1.936-1.067-.521a4.1 4.1 0 00.07-.807z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.058,
    cy: 2.058,
    r: 2.058,
    transform: "translate(3.054 2.822)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3383.809 4976.702a7.192 7.192 0 113.477-4.376m-3.331 7.146a9.767 9.767 0 115.442-5.385",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380.066 4973.134a4.888 4.888 0 01-.6-.061 4.336 4.336 0 01-.55-.129 2.162 2.162 0 01-.426-.175.531.531 0 01-.227-.2.463.463 0 01-.059-.219.5.5 0 01.031-.172.49.49 0 01.087-.149.432.432 0 01.137-.105.407.407 0 01.182-.042.654.654 0 01.227.043c.077.028.163.056.257.083a4.341 4.341 0 00.529.119 3.854 3.854 0 00.627.048 1.671 1.671 0 00.331-.033 1.059 1.059 0 00.3-.107.658.658 0 00.218-.187.466.466 0 00.083-.279.487.487 0 00-.062-.25.635.635 0 00-.169-.184 1.168 1.168 0 00-.25-.138c-.1-.039-.2-.077-.306-.112l-.218-.062-.154-.044-.16-.049-.315-.093a7.066 7.066 0 01-.245-.081l-.187-.067a1.588 1.588 0 01-.751-.509 1.351 1.351 0 01-.252-.844 1.38 1.38 0 01.128-.59 1.406 1.406 0 01.374-.48 1.929 1.929 0 01.6-.338 3.042 3.042 0 01.814-.164v-.282a.3.3 0 01.071-.218.24.24 0 01.178-.072.26.26 0 01.174.065.231.231 0 01.076.184v.32c.194.01.39.027.591.05a2.8 2.8 0 01.548.117 1.183 1.183 0 01.4.215.434.434 0 01.157.346.384.384 0 01-.122.288.432.432 0 01-.318.118h-.039a.2.2 0 01-.039 0 4.74 4.74 0 01-.2-.039l-.212-.042c-.077-.015-.165-.03-.265-.044s-.222-.03-.362-.045l-.177-.015c-.058 0-.116-.007-.172-.007a1.681 1.681 0 00-.327.032 1.14 1.14 0 00-.292.095.609.609 0 00-.209.162.36.36 0 00-.08.235.457.457 0 00.084.279.762.762 0 00.22.2 1.544 1.544 0 00.311.14c.115.039.231.075.347.107l.375.1q.383.118.705.243a2.265 2.265 0 01.555.3 1.241 1.241 0 01.365.427 1.319 1.319 0 01.131.616 1.577 1.577 0 01-.14.671 1.514 1.514 0 01-.4.517 2.01 2.01 0 01-.624.347 3.078 3.078 0 01-.816.16v.312a.69.69 0 01-.01.119.334.334 0 01-.04.105.224.224 0 01-.077.077.242.242 0 01-.125.03.265.265 0 01-.172-.062.231.231 0 01-.074-.188z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3388.829 4981.119l-3.589 3.188-.059-11.822 8.431 8.219z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3353.486 4862.962h54.709v129.342a2 2 0 01-2 2h-50.709a2 2 0 01-2-2v-129.342h0z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3369.527 4891.18h-4.385v-9.6l-1.131 1.043-2.2-2.608 3.028-3 2.6-1.014h4.376l2.591 1.014 3.016 3.012-2.279 2.6-1.233-1.051v9.6h-4.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3369.63 4878.014a2.011 2.011 0 002.011-2.011h-4.022a2.011 2.011 0 002.011 2.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3358.501 4870.756h22.232v25.671h-22.232zm26.654 0h18.368m-18.368 3.439h18.368m-18.368 3.438h18.368m-18.368 3.439h18.368m-18.368 3.438h18.368"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3385.155 4888.13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46 5.84V1.49H0l1.973 4.349z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.879,
    cy: 0.879,
    r: 0.879,
    transform: "translate(2.376 6.539)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.879,
    cy: 0.879,
    r: 0.879,
    transform: "translate(6.703 6.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.461 1.492V.759A.759.759 0 019.219 0h.993m-3.51 7.418H4.133"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3357.747 4825.026h11.845v8.772h-11.845zm17.171 0h11.845v8.772h-11.845zm17.171 0h11.845v8.772h-11.845zm-34.342 17.294h11.845v8.772h-11.845zm17.171 0h11.845v8.772h-11.845zm17.171 0h11.845v8.772h-11.845zm-34.342-5.411h11.845m-11.845 2.301h11.845m5.326-2.301h11.845m-11.845 2.301h11.845m5.326-2.301h11.845m-11.845 2.301h11.845"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.695,
    cy: 14.695,
    r: 14.695,
    transform: "translate(3263.791 4889.924)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3278.486 4916.114a11.5 11.5 0 1111.5-11.5h0a11.5 11.5 0 01-11.5 11.5z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3413.743 4836.909h82.207v44.163",
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3572.592 4891.977)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.695,
    cy: 14.695,
    r: 14.695,
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.691 26.19a11.5 11.5 0 1111.5-11.5 11.5 11.5 0 01-11.5 11.5z",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.86 13.274c.226-1.506-.921-2.315-2.49-2.857l.509-2.041-1.242-.309-.5 1.987c-.326-.082-.66-.158-.995-.234l.5-2-1.242-.31-.509 2.04c-.269-.062-.533-.122-.794-.186v-.007l-1.712-.426-.33 1.327s.922.213.9.224a.66.66 0 01.578.722l-.58 2.324a1.258 1.258 0 01.13.042l-.131-.032-.813 3.256a.453.453 0 01-.568.294c.013.019-.9-.225-.9-.225l-.617 1.421 1.617.4c.3.075.6.155.884.228l-.512 2.063 1.241.31.508-2.041c.339.089.668.176.99.256l-.507 2.032 1.242.309.513-2.06c2.118.4 3.709.24 4.38-1.675a2.179 2.179 0 00-.958-2.93c-.06-.03-.12-.058-.183-.082a1.98 1.98 0 001.591-1.82zm-2.838 3.979c-.383 1.543-2.983.708-3.823.5l.683-2.733c.843.209 3.542.625 3.14 2.232zm.384-4c-.35 1.4-2.511.689-3.212.514l.618-2.478c.7.174 2.958.5 2.594 1.964z",
    fill: "#6e7e9d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3690.15 4912.019c.2-1.316-.806-2.025-2.176-2.5l.445-1.784-1.087-.271-.433 1.737c-.286-.071-.577-.138-.87-.206l.437-1.748-1.086-.271-.445 1.783c-.235-.054-.466-.107-.695-.163l-1.5-.373-.289 1.16s.807.186.79.2a.578.578 0 01.506.63l-.507 2.033c.039.011.076.022.113.036l-.115-.028-.709 2.848a.4.4 0 01-.5.256c.012.016-.79-.2-.79-.2l-.539 1.242 1.414.353c.262.066.521.135.773.2l-.448 1.8 1.085.271.444-1.786c.3.08.585.154.866.225l-.443 1.777 1.085.271.45-1.8c1.851.351 3.243.21 3.83-1.465a1.906 1.906 0 00-.837-2.562 1.674 1.674 0 00-.161-.072 1.73 1.73 0 001.392-1.593zm-2.481 3.479c-.334 1.348-2.609.619-3.343.437l.6-2.39c.737.183 3.1.547 2.746 1.954zm.336-3.5c-.307 1.226-2.2.6-2.808.449l.54-2.167c.613.154 2.586.438 2.268 1.718z",
    fill: "#6e7e9d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3536.405 4906.995h36.187m29.39 0h36.187"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurtherPay);
export default __webpack_public_path__ + "static/media/furtherPay.133e8ca8b8638516638da3af3a462b76.svg";
export { ForwardRef as ReactComponent };